const AUTH_PAGES = ['/auth/login', '/auth/verify', '/auth/recovery', '/auth/reset'];

export const safeNextPath = (raw: string | null): string | null => {
    if (!raw) return null;
    if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return null;
    if (AUTH_PAGES.some((page) => raw === page || raw.startsWith(`${page}?`) || raw.startsWith(`${page}/`))) return null;
    return raw;
};

export default safeNextPath;
